import { FC } from 'react';
import { IconProps } from '../../types';

export const BronzeSmall: FC<IconProps> = ({ width = 12, height = 12, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6003_117396)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
          fill="url(#paint0_linear_6003_117396)"
        />
        <path
          d="M4.24509 1.588H5.74509C6.27309 1.6 6.75309 1.6 7.20909 1.936C7.50909 2.152 7.66509 2.404 7.74909 2.74C7.84509 3.136 7.85709 3.844 7.85709 3.868C7.85709 4.012 7.85709 4.768 7.47309 5.284C7.32909 5.464 7.17309 5.584 6.99309 5.728C7.23309 5.836 7.34109 5.896 7.43709 5.968C7.70109 6.184 8.00109 6.664 8.00109 7.492C8.00109 7.612 7.98909 8.416 7.77309 8.956C7.72509 9.064 7.64109 9.256 7.43709 9.484C7.02909 9.904 6.56109 9.952 6.35709 9.976C5.96109 10.024 5.21709 10.024 4.24509 10.024V1.588ZM5.43309 6.172V9.028C5.81709 9.028 6.17709 9.028 6.45309 8.764C6.68109 8.56 6.81309 8.296 6.81309 7.696C6.81309 7.612 6.80109 7.024 6.59709 6.64C6.56109 6.58 6.48909 6.46 6.32109 6.352C6.05709 6.172 5.75709 6.172 5.43309 6.172ZM5.43309 2.56V5.26C6.02109 5.272 6.22509 5.212 6.44109 4.984C6.60909 4.792 6.74109 4.516 6.74109 3.94C6.74109 3.856 6.74109 3.664 6.69309 3.436C6.66909 3.28 6.58509 2.704 6.02109 2.56C5.82909 2.512 5.62509 2.536 5.43309 2.56Z"
          fill="#FBF4E7"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6003_117396"
          x1="5.6"
          y1="14.4"
          x2="5.6"
          y2="-2.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90674D" />
          <stop offset="0.239" stopColor="#6A2D20" />
          <stop offset="0.464" stopColor="#DFC4A1" />
          <stop offset="1" stopColor="#9B725A" />
        </linearGradient>
        <clipPath id="clip0_6003_117396">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
